import React, { useState } from "react";
import { Eye, EyeOff } from "react-feather";
import axios from "axios";
import { baseurl } from "../../Baseurl";  // Ensure you have the correct baseurl
import { useNavigate } from "react-router-dom"; 
import { Link } from "react-router-dom";

const SuperLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Log the email and password being sent
    console.log("Sending data:", { email, password });
  
    try {
      const response = await axios.post(`${baseurl}superAdminLogin`, { email, password });
  
      // Log the full response object
      console.log("Response received:", response);
  
      // Extract token, userId, and email from the response data
      const {   id, email: adminEmail } = response.data.admin;
  
      // Save token, userId, and email in localStorage
      
      localStorage.setItem("superID", id);
      localStorage.setItem("super_email", adminEmail);
  
 
      console.log("superID:", id);
      console.log("super_email:", adminEmail);
  
      // Navigate to the admin dashboard
      navigate("/superadmin/dashboard");
    } catch (error) {
      console.error("Login failed:", error.response?.data?.message || error.message);
      // Handle login failure (e.g., show error message)
    }
  };
  
  

  return (
    <div className=" ">
      <div className="container d-flex justify-content-center align-items-center vh-100">
      <div>

      <svg xmlns="http://www.w3.org/2000/svg" width="80" height="50" viewBox="0 0 200.39 112.97" className="mx-auto size-16">
      
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path d="M199.54,103.9l-60.27-101a6,6,0,0,0-8.87-1.64L2.3,102.26A6,6,0,0,0,6,113H28.33a6,6,0,0,0,3.72-1.29l91.24-71.9a6,6,0,0,1,8.86,1.64L154,78.06a6,6,0,0,1-5.16,9.08H121.13a6,6,0,0,0-3.69,1.26L99.68,102.24A6,6,0,0,0,103.37,113h91A6,6,0,0,0,199.54,103.9Z" ></path>
          </g></g>
          </svg>


      <div className="mb-3">
            <h3 className="text-dark cl1 h11">Super Admin Login</h3>
            <p className="text-muted">Please sign in to continue</p>
          </div>




          <div
          className="card p-4  "
          style={{ maxWidth: "400px", width: "100%" }}
        >
 
          <form onSubmit={handleSubmit}>
            <div className="mb-3 text-start">
              <label htmlFor="email" className="form-label">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                className="form-control"
                placeholder="Enter Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                 
              />
            </div>
            <div className="mb-3 text-start">
              <label htmlFor="password" className="form-label">
                Password <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  className="form-control"
                  placeholder="Enter Your Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                   
                />
                <div
                  className="pwhide"
                  onClick={togglePasswordVisibility}
                  style={{ cursor: "pointer" }}
                >
                  {showPassword ? 'Show' : 'Hide'}
                </div>
              </div>
            </div>

            <div>
             
 
            </div>


            <div className="mt-3">
              <button type="submit" className="btn submitbtnn w-100">
              Sign In
              </button>
            </div>

 
          </form>
        </div>



      </div>

        
      </div>
    </div>
  );
};

export default SuperLogin;
